import { User } from 'app/projects/user/src/lib/models/user';
import { canAccessExecutionMetadata } from './can-access-execution-metadata.util';

export interface IListingDetailsNavigationParams {
    courseOfferingId?: number | null;
    listingId?: number | null;
    catalogUrl?: string | null;
    isSelfPaced?: boolean;
    canManageTeamBookings?: boolean;
}

export function getListingDetailsNavigationPath(
    params: IListingDetailsNavigationParams,
    user: Pick<User, 'permissions' | 'catalogId'> | null | undefined
): string | null {
    const listingId = params.listingId;
    if (!listingId) {
        return null;
    }

    const courseOfferingId = params.courseOfferingId;
    if (courseOfferingId) {
        if (canAccessExecutionMetadata(user)) {
            return `/admin/offering-details/${courseOfferingId}/catalog/listing/${listingId}/overview`;
        }

        if (user?.catalogId) {
            if (params.isSelfPaced) {
                if (params.canManageTeamBookings) {
                    return `/catalog/course-offerings/${courseOfferingId}/landing-page/overview/team-bookings/${listingId}`;
                }

                return `/catalog/course-offerings/${courseOfferingId}/landing-page/overview`;
            }

            return `/catalog/course-offerings/${courseOfferingId}/landing-page/overview/listing-details/${listingId}`;
        }
    }

    if (canAccessExecutionMetadata(user) || !user?.catalogId) {
        return null;
    }

    const catalogUrl = params.catalogUrl;
    if (!catalogUrl) {
        return null;
    }

    let path: string | null;
    try {
        path = new URL(catalogUrl, window.location.origin).pathname;
    } catch {
        path = catalogUrl.startsWith('/') ? catalogUrl : null;
    }

    if (!path) {
        return null;
    }

    if (params.isSelfPaced) {
        const landingPath = path.replace(/\/listing-details\/\d+(?=\/|$)/, '').replace(/\/team-bookings\/\d+(?=\/|$)/, '');
        if (params.canManageTeamBookings) {
            return `${landingPath.replace(/\/$/, '')}/team-bookings/${listingId}`;
        }

        return landingPath.replace(/\/$/, '') || path;
    }

    if (path.includes('/listing-details/')) {
        return path;
    }

    return `${path.replace(/\/$/, '')}/listing-details/${listingId}`;
}

export function getCourseOfferingLandingNavigationPath(courseOfferingId: string | number): string {
    return `/catalog/course-offerings/${courseOfferingId}/landing-page/overview`;
}

export function getTeamBookingsNavigationPath(courseOfferingId: string | number, listingId: string | number): string {
    return `/catalog/course-offerings/${courseOfferingId}/landing-page/overview/team-bookings/${listingId}`;
}
